module.exports = __webpack_public_path__ + "img/bg.5ae8021f.png";